<template>
  <div>
    <div class="input-wrap">
			<label>解析标题</label>
			<el-input v-model="info.title" placeholder="请输入文章标题" class="input"></el-input>
		</div>
		<div class="input-wrap">
  		<label>项目背景</label>
  		<el-input
			  type="textarea"
			  placeholder="请输入内容"
			  v-model="info.project_background"
			  maxlength="100"
			  show-word-limit
			  :rows="4"
			  class="input"
			>
			</el-input>
  	</div>
    <div class="input-wrap">
      <label>权重</label>
      <el-input type="number" v-model="info.sort" placeholder="0～99,越大越靠前" class="input"></el-input>
    </div>
  	<div class="labels-wrap">
  		<div>选择标签</div>
  		<div class="label-list">
  			<div
  			  v-for="(item, index) of article_label "
  			  :key="item.uuid"
  			  :class="{label_item: true, selected: item.isSelected}"
  			  @click="labelClick(item, index)"
  			>{{item.tag_name}}</div>
  		</div>
  	</div>
  	<div class="upload_img_wrap">
  		<div class="project-icon-wrap">
	  		<div>封面图</div>
	  	  <imageUpload v-model="project_analysis_icon" :limit="1"/>
	  	</div>
	  	<div class="project-banner-wrap">
	  		<div>banner</div>
	  	  <imageUpload v-model="project_analysis_banner" :limit="1"/>
	  	</div>
  	</div>
  	<div class="quill-wrap">
  		<div>用户痛点</div>
  	  <!-- <Quill
        class="dk-li"
        v-model="info.user_pain_point"/> -->
      <dankal-editor
        v-model="info.user_pain_point"
        :config="config"
        height="450px"
      />
    </div>
    <div class="quill-wrap">
  		<div>营运痛点</div>
  	  <!-- <Quill
        class="dk-li"
        v-model="info.operational_pain_points"/> -->
      <dankal-editor
        v-model="info.operational_pain_points"
        :config="config"
        height="450px"
      />
    </div>
    <div class="quill-wrap">
  		<div>发展目标</div>
  	  <!-- <Quill
        class="dk-li"
        v-model="info.development_goals"/> -->
      <dankal-editor
        v-model="info.development_goals"
        :config="config"
        height="450px"
      />
    </div>
    <div class="quill-wrap">
  		<div>用户痛点创造价值</div>
  	  <!-- <Quill
        class="dk-li"
        v-model="info.user_pain_point_value"/> -->
      <dankal-editor
        v-model="info.user_pain_point_value"
        :config="config"
        height="450px"
      />
    </div>
    <div class="quill-wrap">
  		<div>锁定核心</div>
  	  <!-- <Quill
        class="dk-li"
        v-model="info.lock_the_core"/> -->
      <dankal-editor
        v-model="info.lock_the_core"
        :config="config"
        height="450px"
      />
    </div>
    <div class="quill-wrap">
  		<div>页面分解</div>
  	  <!-- <Quill
        class="dk-li"
        v-model="info.page_decomposition"/> -->
      <dankal-editor
        v-model="info.page_decomposition"
        :config="config"
        height="450px"
      />
    </div>
    <div class="quill-wrap">
  		<div>产品聚焦解决方案</div>
  	  <!-- <Quill
        class="dk-li"
        v-model="info.product_focus_solutions"/> -->
      <dankal-editor
        v-model="info.product_focus_solutions"
        :config="config"
        height="450px"
      />
    </div>
     <div class="btns-wrap">
    	<el-button type="primary" @click="confirmClick">确认</el-button>
    	<el-button @click="cancelClick">取消</el-button>
    </div>
  </div>
</template>

<script>
import Quill from '@/components/quill-editor';
import ImageUpload from '@/components/ImageUpload';
import { mapState } from 'vuex';
import { addAnalysis, analysisDetail, editAnalysis } from '@/api/product-analysis';
import DankalEditor from '@/components/editor/dankal-editor';
import Editor from '../../mixins/editor';

export default {
  mixins: [Editor],
  data() {
    return {
    	info: {
    		title: '',
        project_background: '',
        sort: '',
        tag_uuid: '', //多个时逗号拼接
        project_analysis_icon: '',
    		project_analysis_banner: '',
    		user_pain_point: '',
    		operational_pain_points: '',
    		development_goals: '',
    		user_pain_point_value: '',
    		lock_the_core: '',
    		page_decomposition: '',
    		product_focus_solutions: '',
      },
      project_analysis_icon: [],
      project_analysis_banner: [],
      selected_tag: [],
      handleType: 'add',
    };
  },
  computed: {
    ...mapState(['article_label']),
  },
  components: {
  	Quill,
    ImageUpload,
    DankalEditor
  },
  mounted() {
    //每次进入先把标签选中状态清空
    this.handlleLabel();
    let uuid = this.$route.query.uuid;
    if (uuid) {
      this.handleType = 'edit';
      this.getAnalysisDetail(uuid);
    }
    console.log(uuid,'uuid')
    console.log(this.article_label, 'label')
  },
  methods: {
  	labelClick(item, index) {
      item.isSelected = item.isSelected ? !item.isSelected : true;
      //使用set方法 是数据响应更新
      this.$set(this.article_label, index, item)
  	},
  	cancelClick() {
  		this.$router.go(-1);
    },
    handlleLabel() {
      this.article_label.forEach( item => {
        item.isSelected = false;
      })
    },
    async getAnalysisDetail(uuid) {
      const { data, status } = await analysisDetail(uuid);
      if (status !== 200) return
      this.info = data;
      this.project_analysis_icon = [data.project_analysis_icon];
      this.project_analysis_banner = [data.project_analysis_banner];
      this.selected_tag = data.tag_uuid.indexOf(',') !== -1 ? data.tag_uuid.split(',') : [data.tag_uuid];
      this.article_label.forEach( item => {
        if (this.selected_tag.includes(item.uuid)) {
          item.isSelected = true
        } else {
          item.isSelected = false
        }
      })
      console.log( data, 'detail')
    },
    async confirmClick() {
      this.info.project_analysis_icon = this.project_analysis_icon.join('');
      this.info.project_analysis_banner = this.project_analysis_banner.join('');
      //先置空
      this.selected_tag = [];
      this.article_label.forEach(item => {
        if (item.isSelected) {
          //选择的tag
          this.selected_tag.push(item.uuid)
        }
      })
      this.info.tag_uuid = this.selected_tag.join(',');
      const { 
        title, 
        project_background, 
        sort, 
        tag_uuid, 
        project_analysis_icon, 
        project_analysis_banner,
        user_pain_point,
        operational_pain_points,
        development_goals,
        user_pain_point_value,
        lock_the_core,
        page_decomposition,
        product_focus_solutions
      } = this.info;
      if (!title) {
        this.$message('解析标题不能为空');
        return
      }
      if (title.length > 10) {
        this.$message('解析标题不能超过10个字');
        return
      }
      if (!project_background) {
        this.$message('项目背景不能为空');
        return
      }
      if (!sort) {
     	 this.$message('权重不能为空');
     	 return
      }
      if (+sort < 0 || +sort > 99 || sort%1 !== 0) {
     	 this.$message('权重必须为0～99之间的整数');
     	 return
      }
      if (!project_analysis_icon) {
     	 this.$message('封面图片不能为空');
     	 return
      }
      if (!project_analysis_banner) {
     	 this.$message('banner不能为空');
     	 return
      }
      if (!user_pain_point) {
     	 this.$message('用户痛点不能为空');
     	 return
      }
      if (!operational_pain_points) {
     	 this.$message('营运痛点不能为空');
     	 return
      }
      if (!development_goals) {
     	 this.$message('发展目标不能为空');
     	 return
      }
      if (!user_pain_point_value) {
     	 this.$message('用户痛点创造价值不能为空');
     	 return
      }
      if (!lock_the_core) {
     	 this.$message('锁定核心不能为空');
     	 return
      }
      if (!page_decomposition) {
     	 this.$message('页面分解不能为空');
     	 return
      }
      if (!product_focus_solutions) {
     	 this.$message('产品聚焦解决方案');
     	 return
      }
      if (this.handleType === 'add') {
        const { status } = await addAnalysis(this.info);
        if ( status === 200 ) this.$router.go(-1)
      } else if (this.handleType === 'edit') {
        const { status } = await editAnalysis(this.info);
        if ( status === 200 ) this.$router.go(-1)
      } 
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.input-wrap {
	margin-bottom: 20px;
	label {
		display: block;
		margin-bottom: 10px;
	}
	.input {
		width: 400px;
	}
}
.quill-wrap {
	margin-top: 30px;
	margin-bottom: 50px;
}
.btns-wrap {
	display: flex;
	justify-content: center;
}
.label-list {
	display: flex;
	flex-wrap: wrap;
	margin-top: 10px;
	.label_item {
		min-width: 100px;
		height: 40px;
		line-height: 40px;
		text-align: center;
		margin-right: 20px;
		margin-bottom: 10px;
		border: 1px solid #e5e5e5;
		border-radius: 5px;
		cursor: pointer;
	}
	.selected {
		background: @color-text;
		color: #fff;
	}
}
.upload_img_wrap {
	display: flex;
	justify-content: space-between;
	margin-right: 100px;
  margin-top: 20px;
  .project-icon-wrap, .project-banner-wrap {
    max-width: 500px;
    height: auto;
  }
}
</style>
